import { createFileRoute } from '@tanstack/react-router';
import { Board } from '../../features/board/Board.js';
import { boardQueryOptions } from '../../features/board/useBoardQuery.js';
import { BoardSearch } from '../../features/filters/searchSchema.js';

export const Route = createFileRoute('/_authed/board/$boardId')({
  // Typed, schema-validated search params — this is what makes the filter state
  // in the URL a first-class value rather than manual URLSearchParams parsing.
  validateSearch: BoardSearch,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(boardQueryOptions(params.boardId)),
  component: BoardRoute,
});

/**
 * The route owns the URL; `Board` just receives values and a setter.
 *
 * Keeping the coupling here rather than inside the board means no component
 * has to name the route by its string id, and the two cannot drift apart.
 */
function BoardRoute() {
  const { boardId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <Board
      boardId={boardId}
      search={search}
      onSearchChange={(patch) => {
        // `replace` so typing in the filter box does not fill up history.
        void navigate({ search: (current) => ({ ...current, ...patch }), replace: true });
      }}
    />
  );
}
